module.exports = __webpack_public_path__ + "static/como-funciona-bg-0dabc972e243ae3831442ec65c3e515b.jpg";